import React, { useState, useEffect } from "react";

type DiamondItem = {
  id: number;
  image: string;
};

const initialImages: DiamondItem[] = [
  { id: 1, image: "/m1.png" },
  { id: 2, image: "/m2.png" },
  { id: 3, image: "/m3.png" },
  { id: 4, image: "/m4.png" },
  { id: 5, image: "/m5.png" },
  { id: 6, image: "/m6.png" },
  { id: 7, image: "/m7.png" },
  { id: 8, image: "/m8.png" },
  { id: 9, image: "/m9.png" },
  { id: 10, image: "/m10.png" },
  { id: 11, image: "/m11.png" },
  { id: 12, image: "/m12.png" },
  { id: 13, image: "/m13.png" },
  { id: 14, image: "/m14.png" },
  { id: 15, image: "/m15.png" },
];

const titles = [
  "Here, the soul of the street and glam of skyline meet",
  "",
  "The familiar sits beside the unexpected.",
  "",
  "",
  "Tradition is honoured, never frozen",
  "",
  "This is not a replica of the city",
];

// Improved shuffle function using Fisher-Yates algorithm
// const shuffleArray = (array: number[]): number[] => {
//   const shuffled = [...array];
//   for (let i = shuffled.length - 1; i > 0; i--) {
//     // Generate random number with better randomization
//     const randomNum = Math.floor(Math.random() * 1000);
//     const j = randomNum % (i + 1);
//     // Swap
//     [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//   }
//   return shuffled;
// };

// Get random non-repeating indices
// const getRandomNonRepeatingIndices = (): number[] => {
//   // Create array [0, 1, 2, 3]
//   const indices = [0, 1, 2, 3];
//   // Shuffle multiple times to ensure true randomness
//   let shuffled = shuffleArray(indices);
//   // Add extra randomization
//   shuffled = shuffled.sort(() => Math.random() - 0.5);
//   return shuffled;
// };

const DiamondGrid2: React.FC = () => {
  const [images, setImages] = useState(initialImages);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileText] = useState(titles[0]);
  // const useEvenPositions = useRef(false);
  // const useMobilePositions = useRef(0);
  // const lastIndicesRef = useRef<number[]>([0, 1, 2, 3]); // Track last used indices

  // const initializeTitleText = () => {
  //   return new Array(8).fill("");
  // };
  //const [titleText, setTitleText] = useState(initializeTitleText());

  // detect screen size
  useEffect(() => {
    const checkScreen = () => {
      if (window.innerWidth <= 500) setIsMobile(true);
      else setIsMobile(false);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // random swap animation + text rotation
  useEffect(() => {
    //Random images
    const interval = setInterval(() => {
      setImages((prev) => {
        const arr = [...prev];
        if (isMobile) {
          // Only shuffle among the first 4 visible images
          let i = Math.floor(Math.random() * 4);
          let j = Math.floor(Math.random() * 4);

          while (i === j) {
            j = Math.floor(Math.random() * 4);
          }

          [arr[i], arr[j]] = [arr[j], arr[i]];
        } else {
          let i = Math.floor(Math.random() * arr.length);
          let j = Math.floor(Math.random() * arr.length);

          while (i === j) {
            j = Math.floor(Math.random() * arr.length);
          }

          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
      });
    }, 1000);

    //Random text with non-repeating indices
    // const intervalText = setInterval(() => {
    //   setTitleText((prevTitleText) => {
    //     // Create new titleText array
    //     const newTitleText = new Array(8).fill("");

    //     // Toggle between even and odd positions
    //     const positions = useEvenPositions.current
    //       ? [0, 2, 4, 6]
    //       : [1, 3, 5, 7];

    //     // Get random non-repeating indices
    //     let randomIndices = getRandomNonRepeatingIndices();

    //     // Ensure it's different from last time
    //     while (
    //       JSON.stringify(randomIndices) ===
    //       JSON.stringify(lastIndicesRef.current)
    //     ) {
    //       randomIndices = getRandomNonRepeatingIndices();
    //     }

    //     // Store current indices for next comparison
    //     lastIndicesRef.current = randomIndices;

    //     console.log("Random Indices:", randomIndices); // Debug log

    //     // Fill positions with title values using random indices
    //     positions.forEach((pos, posIdx) => {
    //       const idx = randomIndices[posIdx];
    //       newTitleText[pos] = titles[idx];
    //       console.log(`Position ${pos} -> Title ${idx}: ${titles[idx]}`); // Debug log
    //     });

    //     // Toggle the position type for next cycle
    //     useEvenPositions.current = !useEvenPositions.current;

    //     return newTitleText;
    //   });

    //   // Handle mobile text separately
    //   setMobileText((prevMobileText) => {
    //     const currentIndex = useMobilePositions.current;
    //     useMobilePositions.current =
    //       (useMobilePositions.current + 1) % titles.length;
    //     return titles[currentIndex];
    //   });
    // }, 5000);

    return () => {
      clearInterval(interval);
      //clearInterval(intervalText);
    };
  }, [isMobile]); // Added isMobile to dependency array

  // only 4 images on mobile
  const displayImages = isMobile ? images.slice(0, 4) : images;

  return (
    <section className="kdiamond-section">
      <div className="hero-border">
        <h2 className="mdiamond-heading">
          Modern Indian dining shaped by memory,
          <br className="desktop-break" /> movement, and generosity.
        </h2>

        <div className="mdiamond-container" style={{ position: "relative" }}>
          <div className="kdiamond-wrapper">
            <div className="kdiamond-grid">
              {displayImages.map((item) => (
                <div key={item.id} className="kdiamond">
                  <div className="kdiamond-inner">
                    <img src={item.image} alt="" />
                  </div>
                </div>
              ))}
              {/* Text in the gaps between diamonds */}

              <div className="kdiamond-gap-text text-gap gap-text-1">
                {isMobile ? mobileText : titles[0]}
              </div>
              {!isMobile && (
                <>
                  <div className="kdiamond-gap-text text-gap gap-text-2">
                    {titles[1]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-3">
                    {titles[2]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-4">
                    {titles[3]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-5">
                    {titles[4]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-6">
                    {titles[5]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-7">
                    {titles[6]}
                  </div>
                  <div className="kdiamond-gap-text text-gap gap-text-8">
                    {titles[7]}
                  </div>
                </>
              )}
              {/* Add more as needed */}
            </div>
          </div>
        </div>

        <p>It's a reflection of how it lives today</p>
      </div>
    </section>
  );
};

export default DiamondGrid2;
